import Cookies from "js-cookie";
import {
  ASSIGN_INSTITUTION_BATCH_STUDENT,
  CREATE_INSTITUTION_COURSE_BATCH_URL,
  CREATE_INSTITUTION_COURSE_URL,
  CREATE_INSTITUTION_STUDENT_URL,
  CREATE_INSTITUTION_TEACHER_URL,
  CREATE_INSTITUTION_URL,
  DELETE_INSTITUTION_COURSE_BATCH_URL,
  DELETE_INSTITUTION_STUDENT_URL,
  DELETE_INSTITUTION_TEACHER_URL,
  DELETE_INSTITUTION_URL,
  GET_ALL_INSTITUTION_BATCH_STUDENT,
  GET_ALL_INSTITUTION_COURSE_BATCH_URL,
  GET_ALL_INSTITUTION_COURSE_URL,
  GET_ALL_TEACHER_COURSE_URL,
  GET_ALL_INSTITUTION_STUDENT_URL,
  GET_ALL_INSTITUTION_TEACHER_URL,
  GET_ALL_INSTITUTION_URL,
  GET_ALL_NOT_IN_INSTITUTION_COURSE_LIST_URL,
  GET_INSTITUTION_BATCH_TEACHER,
  GET_ONE_INSTITUTION_BATCH_TEACHER,
  GET_SINGLE_INSTITUTION_URL,
  GET_WITHOUT_ASSIGN_STUDENT_URL,
  GET_WITHOUT_ASSIGN_TEACHER_URL,
  INSTITUTION_STUDENT_BULK_UPLOAD,
  INSTITUTION_TEACHER_BULK_UPLOAD,
  UPDATE_INSTITUTION_COURSE_BATCH_URL,
  UPDATE_INSTITUTION_COURSE_URL,
  UPDATE_INSTITUTION_STUDENT_URL,
  UPDATE_INSTITUTION_TEACHER_URL,
  UPDATE_INSTITUTION_URL,
  ASSIGN_TEACHER_SUBJECTS_INSTITUTION_URL,
  ASSIGN_TEACHER_SUBJECTS_ADMIN_URL,
  GET_TEACHER_SUBJECT_ASSIGNMENT_INSTITUTION_URL,
  GET_TEACHER_SUBJECT_ASSIGNMENT_ADMIN_URL,
  GET_ONE_BATCH_INSTITUTION_URL,
  GET_ONE_BATCH_ADMIN_URL,
  RESET_INSTITUTION_TEACHER_PASSWORD_URL,
  RESET_INSTITUTION_STUDENT_PASSWORD_URL,
} from "../apiurls/apiurls";

export const getAllInstitution = async (token, params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.board) query.set("board", String(params.board));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = query.toString()
    ? `${GET_ALL_INSTITUTION_URL}?${query.toString()}`
    : `${GET_ALL_INSTITUTION_URL}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching institutions:", error);
    throw error;
  }
};

export const getSingleInstitution = async (token, id) => {
  try {
    const response = await fetch(`${GET_SINGLE_INSTITUTION_URL}?id=${id}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createInstitution = async (payload, token) => {
  try {
    const response = await fetch(`${CREATE_INSTITUTION_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateInstitution = async (payload, token, id) => {
  try {
    const response = await fetch(`${UPDATE_INSTITUTION_URL}?id=${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteInstitution = async (token, id) => {
  try {
    const response = await fetch(`${DELETE_INSTITUTION_URL}?id=${id}`, {
      method: "DELETE",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllInstitutionTeacher = async (
  token,
  id,
  role,
  params = {}
) => {
  const query = new URLSearchParams({
    institution: String(id ?? ""),
  });

  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.role) query.set("role", String(params.role));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_INSTITUTION_TEACHER_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createInstitutionTeacher = async (token, payload) => {
  const url = `${CREATE_INSTITUTION_TEACHER_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const bulkUploadInstitutionTeacher = async (token, file, id) => {
  const url = `${INSTITUTION_TEACHER_BULK_UPLOAD}?institution=${id}`;
  const formData = new FormData();
  formData.append("file", file);
  console.log(formData, "form");

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const bulkUploadInstitutionStudent = async (token, file, id) => {
  const url = `${INSTITUTION_STUDENT_BULK_UPLOAD}?institution=${id}`;
  const formData = new FormData();
  formData.append("file", file);
  console.log(formData, "form");

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateInstitutionTeacher = async (token, id, payload) => {
  const url = `${UPDATE_INSTITUTION_TEACHER_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteInstitutionTeacher = async (token, id) => {
  try {
    const response = await fetch(`${DELETE_INSTITUTION_TEACHER_URL}?id=${id}`, {
      method: "DELETE",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllInstitutionStudent = async (token, id, params = {}) => {
  const query = new URLSearchParams({ institution: String(id ?? "") });
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.grade) query.set("grade", String(params.grade));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_INSTITUTION_STUDENT_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createInstitutionStudent = async (token, payload) => {
  const url = `${CREATE_INSTITUTION_STUDENT_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateInstitutionStudent = async (token, id, payload) => {
  const url = `${UPDATE_INSTITUTION_STUDENT_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteInstitutionStudent = async (token, id) => {
  try {
    const response = await fetch(`${DELETE_INSTITUTION_STUDENT_URL}?id=${id}`, {
      method: "DELETE",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllInstitutionCourse = async (token, id, params = {}) => {
  const query = new URLSearchParams();
  if (id !== undefined && id !== null && id !== "") {
    query.set("institution", String(id));
  }
  if (params.search) query.set("search", String(params.search));
  if (params.board) query.set("board", String(params.board));
  if (params.class_name) query.set("class_name", String(params.class_name));
  const role = Cookies.get("role");
  const baseUrl = (role === "institution" || role === "teacher") ? GET_ALL_TEACHER_COURSE_URL : GET_ALL_INSTITUTION_COURSE_URL;
  const queryString = query.toString();
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllInstitutionCourseBatch = async (
  token,
  institution,
  course,
  params = {}
) => {
  const query = new URLSearchParams({
    institution: String(institution ?? ""),
    course_key: String(course ?? ""),
  });
  if (params.search) query.set("search", String(params.search));
  const url = `${GET_ALL_INSTITUTION_COURSE_BATCH_URL}?${query.toString()}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createInstitutionCourseBatch = async (token, payload) => {
  const url = `${CREATE_INSTITUTION_COURSE_BATCH_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateInstitutionCourseBatch = async (token, id, payload) => {
  const url = `${UPDATE_INSTITUTION_COURSE_BATCH_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteInstitutionCourseBatch = async (token, id) => {
  try {
    const response = await fetch(
      `${DELETE_INSTITUTION_COURSE_BATCH_URL}?id=${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: token,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllNotInInstitutionCourse = async (token, institution) => {
  try {
    const response = await fetch(
      `${GET_ALL_NOT_IN_INSTITUTION_COURSE_LIST_URL}?institution_id=${institution}`,

      {
        method: "GET",
        headers: {
          Authorization: token,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateInstitutionCourse = async (token, id, payload) => {
  const url = `${UPDATE_INSTITUTION_COURSE_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createInstitutionCourse = async (token, payload) => {
  const url = `${CREATE_INSTITUTION_COURSE_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getOneInstitutionBatchTeacher = async (
  token,
  batch,
  params = {}
) => {
  const query = new URLSearchParams({ batch_id: String(batch ?? "") });
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_INSTITUTION_BATCH_TEACHER}?${query.toString()}`;
  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllInstitutionBatchStudent = async (
  token,
  batch,
  params = {}
) => {
  const query = new URLSearchParams({ batch_id: String(batch ?? "") });
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_INSTITUTION_BATCH_STUDENT}?${query.toString()}`;
  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const assignInstitutionBatchStudent = async (token, payload) => {
  const url = `${ASSIGN_INSTITUTION_BATCH_STUDENT}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllBatchNotAssignStudent = async (token, id) => {
  const url = `${GET_WITHOUT_ASSIGN_STUDENT_URL}?institution=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllBatchNotAssignTeacher = async (token, id) => {
  const url = `${GET_WITHOUT_ASSIGN_TEACHER_URL}?batch_id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

/**
 * Assign (or update) subjects for a specific teacher in a batch.
 * Works for both Institution Admin, Teacher, and Super Admin.
 * @param {string} token - auth token
 * @param {{ batch_id: string, teacher_id: string, subject_ids: string[] }} payload
 */
export const assignTeacherSubjects = async (token, payload) => {
  const role = Cookies.get("role");
  const isInstitution = role === "institution" || role === "teacher";
  const url = isInstitution
    ? ASSIGN_TEACHER_SUBJECTS_INSTITUTION_URL
    : ASSIGN_TEACHER_SUBJECTS_ADMIN_URL;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    return await response.json();
  } catch (error) {
    console.error("Error assigning teacher subjects:", error);
    throw error;
  }
};

/**
 * Fetch the current subject assignment for a teacher in a batch.
 * @param {string} token - auth token
 * @param {string} batchId
 * @param {string} teacherId
 */
export const getTeacherSubjectAssignment = async (token, batchId, teacherId) => {
  const role = Cookies.get("role");
  const isInstitution = role === "institution" || role === "teacher";
  const baseUrl = isInstitution
    ? GET_TEACHER_SUBJECT_ASSIGNMENT_INSTITUTION_URL
    : GET_TEACHER_SUBJECT_ASSIGNMENT_ADMIN_URL;
  const url = `${baseUrl}?batch_id=${batchId}&teacher_id=${teacherId}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Authorization: token },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching teacher subject assignment:", error);
    throw error;
  }
};

/**
 * Fetch a single batch by ID. Auto-picks admin vs institution endpoint.
 */
export const getOneBatch = async (token, batchId) => {
  const role = Cookies.get("role");
  const isInstitution = role === "institution" || role === "teacher";
  const baseUrl = isInstitution ? GET_ONE_BATCH_INSTITUTION_URL : GET_ONE_BATCH_ADMIN_URL;
  const url = `${baseUrl}?id=${batchId}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { Authorization: token },
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching batch:", error);
    throw error;
  }
};

export const resetInstitutionTeacherPassword = async (token, id, payload) => {
  const url = `${RESET_INSTITUTION_TEACHER_PASSWORD_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error resetting teacher password:", error);
    throw error;
  }
};

export const resetInstitutionStudentPassword = async (token, id, payload) => {
  const url = `${RESET_INSTITUTION_STUDENT_PASSWORD_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let msg = `HTTP error! status: ${response.status}`;
      try {
        const errJson = await response.json();
        if (errJson && (errJson.message || errJson.error)) {
          msg = String(errJson.message || errJson.error);
        }
      } catch (_) {}
      throw new Error(msg);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error resetting student password:", error);
    throw error;
  }
};
